import 'primereact/resources/primereact.min.css'; // Core styles
import 'primeicons/primeicons.css'; // Icons
import './styles/main.css'; // Custom global styles

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import { initializeMsal, msalInstance } from './utils/msalConfig';
import { MsalProvider } from '@azure/msal-react';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
initializeMsal().then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});
<link
    id="theme-css"
    rel="stylesheet"
    href="/themes/mdc-light-indigo/theme.css"
/>